import { formatRupiah, realisasiOf, timLabel } from "@/lib/agenda";

// Tabel Agenda Kegiatan per bagian (halaman publik Pengumuman)
export default function AgendaTable({ entries, groupLabel, testId }) {
  const pj = timLabel(groupLabel);
  return (
    <div className="overflow-x-auto rounded-2xl border border-[#E3EBF3] bg-white">
      <table data-testid={testId} className="w-full min-w-[720px] text-left text-xs">
        <thead>
          <tr className="border-b border-[#E3EBF3] bg-[#FBFDFF] text-[10px] font-bold uppercase tracking-[0.1em] text-slate-400">
            <th className="w-12 px-4 py-3">No</th>
            <th className="px-4 py-3">Nama Kegiatan</th>
            <th className="px-4 py-3">Penanggungjawab</th>
            <th className="px-4 py-3">Realisasi</th>
            <th className="px-4 py-3">Waktu Pelaksanaan</th>
            <th className="px-4 py-3 text-right">Jumlah Anggaran</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e, idx) => {
            const r = realisasiOf(e.realisasi);
            return (
              <tr
                key={e.id}
                data-testid={`agenda-entry-${e.id}`}
                className="border-b border-[#E3EBF3] last:border-b-0"
              >
                <td className="px-4 py-3 font-semibold text-slate-400">{idx + 1}</td>
                <td className="px-4 py-3 font-bold text-[#0B2440]">{e.title}</td>
                <td className="px-4 py-3 text-slate-600">{pj}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${r.cls}`}>
                    {r.label}
                  </span>
                </td>
                <td className="px-4 py-3 text-slate-600">{e.waktu || e.date || "—"}</td>
                <td className="whitespace-nowrap px-4 py-3 text-right font-semibold text-[#0B2440]">
                  {formatRupiah(e.anggaran)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
